var components = {
  'application'         : 'application',
  'landing'             : 'landing',
  'text-landing'        : 'textlanding',
  'video-landing'       : 'videolanding',
  'program-info'        : 'programinfo',
  'webinar'             : 'webinar',
  'webinar-custom'      : 'webinarcustom',
  'custom'              : 'custom',
  'blank'               : 'blank'
}

export default components;